import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DragHandleIcon(props: IconProps) {
    return <Icon {...props} iconKey={"drag_handle"}/>
}
